import React, { Component } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";

class CallRequestConfirm extends Component {
  state = {};
  hand;
  render() {
    const { open, onClose, content, onConfirm } = this.props;
    return (
      <div>
        <Dialog open={open} onClose={onClose}>
          <DialogTitle>درخواست تماس</DialogTitle>
          <DialogContent>
            <Typography variant="body2">{content}</Typography>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={onClose}>
              انصراف
            </Button>
            <Button
              color="error"
              variant="outlined"
              onClick={onConfirm}
              autoFocus
            >
              تایید
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default CallRequestConfirm;
